module.exports = __webpack_public_path__ + "img/date_night3.6085afce.png";